<template>
  <div>
    <div id="dropdown" />

    <InstallAppBanner/>
    <div class="w-full lg:flex lg:flex-col">
      <div class="lg:flex lg:flex-col lg:h-screen">
        <div class="fixed w-full z-10 flex lg:flex-shrink-0">
          <div class="flex items-center justify-between px-4 lg:px-6 py-2 md:py-4 bg-white lg:flex-shrink-0 lg:justify-center w-80 lg:w-64 border-b ">
            <Link class="flex items-center mt-1 lg:mr-7 h-10" href="/">
              <a v-if="canQuit && test" href="/" @click="pauseExam"><i class="fas text-lg md:text-2xl fa-arrow-left"></i></a>
              <a v-else-if="canQuit" href="/" onclick="history.back()"><i class="fas text-lg md:text-2xl fa-arrow-left"></i></a>
              <logo v-else class="fill-white w-32 lg:w-40" />
            </Link>
            <a v-if="!hideSidebar" class="hidden lg:block" role="button" @click="removeSidebar = !removeSidebar">
              <svg class="w-6 h-6 fill-secondary-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
            </a>
          </div>

          <div class="lg:text-md flex items-center justify-end py-2 md:py-4 px-4 w-full text-sm bg-white border-b lg:px-12 lg:py-0">
            <span v-if="config.env != 'production'" class="bg-red-100 text-red-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-red-900 dark:text-red-300">{{ __('general.' + config.env ) }}</span>
            <div v-if="canQuit && test" href="/" @click="pauseExam"><i class="cursor-pointer fas bold text-lg md:text-2xl fa-pause"></i></div>
            <a v-else-if="canQuit" href="/" onclick="history.back()"><i class="fas bold text-lg md:text-2xl fa-times"></i></a>
            <user-dropdown v-else :auth="auth" :avatar="avatar" :config="config"></user-dropdown>
          </div>
        </div>
        <div class="pt-[69px] lg:flex lg:flex-grow lg:overflow-hidden">
          <main-menu  v-if="!removeSidebar && !hideSidebar" :class="{'-left-full': !showSidebar, 'left-0': showSidebar}" class="lg:left-0 transition-all ease duration-100 fixed lg:relative z-10  flex-shrink-0 p-12 h-full w-full lg:w-64 bg-white overflow-y-auto lg:block" />
          <div class="relative px-4 pt-4 pb-32 lg:py-4 lg:py-6 lg:flex-1 lg:p-12 lg:overflow-y-auto" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>

  <mobile-tabs v-if="!hideSidebar"></mobile-tabs>
</template>

<script>
import { Inertia } from '@inertiajs/inertia'
import { onUnmounted } from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import MobileTabs from '@/Shared/Navigation/MobileTabs'
import UserDropdown from './Layout/UserDropdown'
// import DgvtLegal from './Navigation/DgvtLegal'

import {pauseTest} from '../api/TestApi'
import Alert from './Navigation/InstallAppBanner.vue'

export default {
  components: {
    Alert,
    UserDropdown,
    FlashMessages,
    Link,
    Logo,
    MainMenu,
    MobileTabs,
  },
  props: {
    auth: Object,
    config: Object,
    hideSidebar: {
      type: Boolean,
      required: false,
    },
    canQuit: {
      type: Boolean,
      required: false,
      default: false,
    },
    test: {
      type: Object,
      required: false,
    },
  },

  setup() {
    onUnmounted(
        Inertia.on('start', (event) => {
          // eslint-disable-next-line no-undef
          _paq.push(['setCustomUrl', '/' + event.detail.visit.url ])
          // eslint-disable-next-line no-undef
          _paq.push(['setDocumentTitle', document.title])
          // eslint-disable-next-line no-undef
          _paq.push(['trackPageView'])
        }),
    )
  },

  data() {
    return {
      // showSidebar moves left position
      // hideSidebar handles the display class
      showSidebar: false,
      removeSidebar: this.hideSidebar,
    }
  },

  computed: {
    avatar() {
      if( ! this.auth || ! this.auth.user || ! this.auth.user.photo_path ) return false
      let avatar = this.auth.user.photo_path
      return `/img/${avatar}?w=60&amp;h=60&amp;fit=crop`
    },
  },

  methods: {
    toggleSidebar: function() {
      this.showSidebar = ! this.showSidebar
    },

    pauseExam: async function() {
      if(confirm("Möchtest Du die Prüfung unterbrechen? Die kannst Sie jederzeit fortsetzen.")){
        await pauseTest(this.test.id)
        location.href = '/meine-pruefungen'
      }
    },
  },

}
</script>
